import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../ui/card";
import { Button } from "../ui/button";
import { Check, Package } from "lucide-react";
import { signOut } from 'firebase/auth';
import { auth } from '../../firebase/firebaseConfig';

function ThankYouPreShipment({ isReturningUser = false }) {
  const handleSignOut = async () => {
    try {
      await signOut(auth);
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 p-4 flex items-center justify-center">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            <div className={`w-16 h-16 ${isReturningUser ? 'bg-blue-100' : 'bg-green-100'} rounded-full flex items-center justify-center`}>
              {isReturningUser ? (
                <Package className="h-8 w-8 text-blue-600" />
              ) : (
                <Check className="h-8 w-8 text-green-600" />
              )}
            </div>
          </div>
          <CardTitle className="text-2xl">
            {isReturningUser ? 'Shipping Information on File' : 'Shipping Addresses Confirmed!'}
          </CardTitle>
          <CardDescription className="text-base space-y-3 mt-4 text-left">
            {isReturningUser ? (
              <>
                <p>We have your shipping addresses on file.</p>
                <p>You will receive an email notification when your Hearth(s) ship.</p>
                <p>
                  If you need to update your shipping information or have any questions, please contact us at{' '}
                  <a
                    href="mailto:hq@higlo.co"
                    className="font-medium text-gray-900 hover:underline"
                  >
                    hq@higlo.co
                  </a>
                </p>
              </>
            ) : (
              <>
                <p>Thank you! We have received your shipping addresses.</p>
                <p>You will receive an email notification when your Hearth(s) ship.</p>
                <p>
                  If you have any questions, please contact us at{' '}
                  <a
                    href="mailto:hq@higlo.co"
                    className="font-medium text-gray-900 hover:underline"
                  >
                    hq@higlo.co
                  </a>
                </p>
              </>
            )}
          </CardDescription>
        </CardHeader>
        <CardContent className="flex justify-center pt-4">
          <Button
            onClick={handleSignOut}
            variant="outline"
            className="w-full max-w-xs"
          >
            Sign Out
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}

export default ThankYouPreShipment;
